export default "__VITE_ASSET__c639ea3b__"